import _defineProperty from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import { Build, h, Host, proxyCustomElement } from '@stencil/core/internal/client';
import { i as isStr, b as inheritAttributes, g as getUrl, c as getName } from './utils.js';

var validateContent = function validateContent(svgContent) {
  var div = document.createElement('div');
  div.innerHTML = svgContent; // setup this way to ensure it works on our buddy IE

  for (var i = div.childNodes.length - 1; i >= 0; i--) {
    if (div.childNodes[i].nodeName.toLowerCase() !== 'svg') {
      div.removeChild(div.childNodes[i]);
    }
  } // must only have 1 root element


  var svgElm = div.firstElementChild;

  if (svgElm && svgElm.nodeName.toLowerCase() === 'svg') {
    var svgClass = svgElm.getAttribute('class') || '';
    svgElm.setAttribute('class', (svgClass + ' s-ion-icon').trim()); // root element must be an svg
    // lets double check we've got valid elements
    // do not allow scripts

    if (isValid(svgElm)) {
      return div.innerHTML;
    }
  }

  return '';
};

var isValid = function isValid(elm) {
  if (elm.nodeType === 1) {
    if (elm.nodeName.toLowerCase() === 'script') {
      return false;
    }

    for (var i = 0; i < elm.attributes.length; i++) {
      var val = elm.attributes[i].value;

      if (isStr(val) && val.toLowerCase().indexOf('on') === 0) {
        return false;
      }
    }

    for (var _i = 0; _i < elm.childNodes.length; _i++) {
      if (!isValid(elm.childNodes[_i])) {
        return false;
      }
    }
  }

  return true;
};

var ioniconContent = new Map();
var requests = new Map();

var getSvgContent = function getSvgContent(url, sanitize) {
  // see if we already have a request for this url
  var req = requests.get(url);

  if (!req) {
    if (typeof fetch !== 'undefined' && typeof document !== 'undefined') {
      // we don't already have a request
      req = fetch(url).then(function (rsp) {
        if (rsp.ok) {
          return rsp.text().then(function (svgContent) {
            if (svgContent && sanitize !== false) {
              svgContent = validateContent(svgContent);
            }

            ioniconContent.set(url, svgContent || '');
          });
        }

        ioniconContent.set(url, '');
      }); // cache for the same requests

      requests.set(url, req);
    } else {
      // set to empty for ssr scenarios and resolve promise
      ioniconContent.set(url, '');
      return Promise.resolve();
    }
  }

  return req;
};

var iconCss = ":host{display:inline-block;width:1em;height:1em;contain:strict;fill:currentColor;-webkit-box-sizing:content-box !important;box-sizing:content-box !important}:host .ionicon{stroke:currentColor}.ionicon-fill-none{fill:none}.ionicon-stroke-width{stroke-width:32px;stroke-width:var(--ionicon-stroke-width, 32px)}.icon-inner,.ionicon,svg{display:block;height:100%;width:100%}:host(.flip-rtl) .icon-inner{-webkit-transform:scaleX(-1);transform:scaleX(-1)}:host(.icon-small){font-size:18px !important}:host(.icon-large){font-size:32px !important}:host(.ion-color){color:var(--ion-color-base) !important}:host(.ion-color-primary){--ion-color-base:var(--ion-color-primary, #3880ff)}:host(.ion-color-secondary){--ion-color-base:var(--ion-color-secondary, #0cd1e8)}:host(.ion-color-tertiary){--ion-color-base:var(--ion-color-tertiary, #f4a942)}:host(.ion-color-success){--ion-color-base:var(--ion-color-success, #10dc60)}:host(.ion-color-warning){--ion-color-base:var(--ion-color-warning, #ffce00)}:host(.ion-color-danger){--ion-color-base:var(--ion-color-danger, #f14141)}:host(.ion-color-light){--ion-color-base:var(--ion-color-light, #f4f5f8)}:host(.ion-color-medium){--ion-color-base:var(--ion-color-medium, #989aa2)}:host(.ion-color-dark){--ion-color-base:var(--ion-color-dark, #222428)}";

var Icon = /*#__PURE__*/function (_HTMLElement) {
  _inherits(Icon, _HTMLElement);

  var _super = _createSuper(Icon);

  function Icon() {
    var _this;

    _classCallCheck(this, Icon);

    _this = _super.call(this);

    _this.__registerHost();

    _this.__attachShadow();

    _this.iconName = null;
    _this.inheritedAttributes = {};
    _this.isVisible = false;
    /**
     * The mode determines which platform styles to use.
     */

    _this.mode = getIonMode();
    /**
     * If enabled, ion-icon will be loaded lazily when it's visible in the viewport.
     * Default, `false`.
     */

    _this.lazy = false;
    /**
     * When set to `false`, SVG content that is HTTP fetched will not be checked
     * if the response SVG content has any `<script>` elements, or any attributes
     * that start with `on`, such as `onclick`.
     * @default true
     */

    _this.sanitize = true;

    _this.hasAriaHidden = function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          el = _assertThisInitialize.el;

      return el.hasAttribute('aria-hidden') && el.getAttribute('aria-hidden') === 'true';
    };

    return _this;
  }

  _createClass(Icon, [{
    key: "componentWillLoad",
    value: function componentWillLoad() {
      this.inheritedAttributes = inheritAttributes(this.el, ['aria-label']);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;

      // purposely do not return the promise here because loading
      // the svg file should not hold up loading the app
      // only load the svg if it's visible
      this.waitUntilVisible(this.el, '50px', function () {
        _this2.isVisible = true;

        _this2.loadIcon();
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.io) {
        this.io.disconnect();
        this.io = undefined;
      }
    }
  }, {
    key: "waitUntilVisible",
    value: function waitUntilVisible(el, rootMargin, cb) {
      var _this3 = this;

      if (Build.isBrowser && this.lazy && typeof window !== 'undefined' && window.IntersectionObserver) {
        var io = this.io = new window.IntersectionObserver(function (data) {
          if (data[0].isIntersecting) {
            io.disconnect();
            _this3.io = undefined;
            cb();
          }
        }, {
          rootMargin: rootMargin
        });
        io.observe(el);
      } else {
        // browser doesn't support IntersectionObserver
        // so just fallback to always show it
        cb();
      }
    }
  }, {
    key: "loadIcon",
    value: function loadIcon() {
      var _this4 = this;

      if (Build.isBrowser && this.isVisible) {
        var url = getUrl(this);

        if (url) {
          if (ioniconContent.has(url)) {
            // sync if it's already loaded
            this.svgContent = ioniconContent.get(url);
          } else {
            // async if it hasn't been loaded
            getSvgContent(url, this.sanitize).then(function () {
              return _this4.svgContent = ioniconContent.get(url);
            });
          }
        }
      }

      var label = this.iconName = getName(this.name, this.icon, this.mode, this.ios, this.md);
      /**
       * Come up with a default label
       * in case user does not provide their own.
       */

      if (label) {
        this.ariaLabel = label.replace(/\-/g, ' ');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _Object$assign2;

      var iconName = this.iconName,
          ariaLabel = this.ariaLabel,
          inheritedAttributes = this.inheritedAttributes;
      var mode = this.mode || 'md';
      var flipRtl = this.flipRtl || iconName && (iconName.indexOf('arrow') > -1 || iconName.indexOf('chevron') > -1) && this.flipRtl !== false;
      /**
       * Only set the aria-label if a) we have generated
       * one for the icon and if aria-hidden is not set to "true".
       * If developer wants to set their own aria-label, then
       * inheritedAttributes down below will override whatever
       * default label we have set.
       */

      return h(Host, Object.assign({
        "aria-label": ariaLabel !== undefined && !this.hasAriaHidden() ? ariaLabel : null,
        role: "img",
        class: Object.assign(Object.assign(_defineProperty({}, mode, true), createColorClasses(this.color)), (_Object$assign2 = {}, _defineProperty(_Object$assign2, "icon-".concat(this.size), !!this.size), _defineProperty(_Object$assign2, 'flip-rtl', !!flipRtl && this.el.ownerDocument.dir === 'rtl'), _Object$assign2))
      }, inheritedAttributes), Build.isBrowser && this.svgContent ? h("div", {
        class: "icon-inner",
        innerHTML: this.svgContent
      }) : h("div", {
        class: "icon-inner"
      }));
    }
  }, {
    key: "el",
    get: function get() {
      return this;
    }
  }], [{
    key: "assetsDirs",
    get: function get() {
      return ["svg"];
    }
  }, {
    key: "watchers",
    get: function get() {
      return {
        "name": ["loadIcon"],
        "src": ["loadIcon"],
        "icon": ["loadIcon"]
      };
    }
  }, {
    key: "style",
    get: function get() {
      return iconCss;
    }
  }]);

  return Icon;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var getIonMode = function getIonMode() {
  return Build.isBrowser && typeof document !== 'undefined' && document.documentElement.getAttribute('mode') || 'md';
};

var createColorClasses = function createColorClasses(color) {
  return color ? _defineProperty({
    'ion-color': true
  }, "ion-color-".concat(color), true) : null;
};

Icon = /*@__PURE__*/proxyCustomElement(Icon, [1, "ion-icon", {
  "mode": [1025],
  "color": [1],
  "ios": [1],
  "md": [1],
  "flipRtl": [4, "flip-rtl"],
  "name": [513],
  "src": [1],
  "icon": [8],
  "size": [1],
  "lazy": [4],
  "sanitize": [4],
  "svgContent": [32],
  "isVisible": [32],
  "ariaLabel": [32]
}]);

function defineCustomElement$1() {
  var components = ["ion-icon"];
  components.forEach(function (tagName) {
    switch (tagName) {
      case "ion-icon":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, Icon);
        }

        break;
    }
  });
}

var IonIcon = Icon;
var defineCustomElement = defineCustomElement$1;
export { IonIcon, defineCustomElement };